<template>
  <nav class="border-b border-border-navbar flex justify-between pl-10 pr-8 py-4 w-full items-center gap-6">
    <b-search class="w-[423px] shrink-0" />
    <div class="flex items-center gap-6">
      <!-- notification bell slot -->
      <slot name="actions" />
    </div>
  </nav>
</template>

<script setup lang="ts">
import BSearch from "~/components/navigation/search/BSearch.vue";
</script>
